"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Evexia API
 * OpenAPI Spec for Evexia APIs
 *
 * The version of the OpenAPI document: 1.0
 * Contact: ch_engineering@calm.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetDocumentSignedUrlV1UrlTypeEnum = exports.GetDocumentSignedUrlV1TypeEnum = exports.DownloadDocumentV1TypeEnum = exports.DocumentApi = exports.DocumentApiFactory = exports.DocumentApiFp = exports.DocumentApiAxiosParamCreator = void 0;
const tslib_1 = require("tslib");
const axios_1 = tslib_1.__importDefault(require("axios"));
// @ts-ignore
const base_1 = require("../base");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
/**
 * DocumentApi - axios parameter creator
 */
const DocumentApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Create document for recipient |Feature|Dataclass|Permission| |-------|---------|----------| |documents|document|c|
         * @summary Creates a document for the recipient.
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {DocumentCreateDocumentRequest} documentCreateDocumentRequest Create document request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDocumentV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, documentCreateDocumentRequest, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('createDocumentV1', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('createDocumentV1', 'recipientId', recipientId);
            // verify required parameter 'documentCreateDocumentRequest' is not null or undefined
            (0, common_1.assertParamExists)('createDocumentV1', 'documentCreateDocumentRequest', documentCreateDocumentRequest);
            const localVarPath = `/v1/documents/recipients/{recipient_id}/documents`.replace('{recipient_id}', encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (circleAuthorizationToken != null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/documents/recipients/{recipient_id}/documents`,
                sdkMethod: 'createDocumentV1',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(documentCreateDocumentRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Create a tag |Feature|Dataclass|Permission| |-------|---------|----------| |documents|document|c|
         * @summary Creates a tag.
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {DocumentCreateTagRequest} documentCreateTagRequest Create tag request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTagV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, documentCreateTagRequest, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('createTagV1', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('createTagV1', 'recipientId', recipientId);
            // verify required parameter 'documentCreateTagRequest' is not null or undefined
            (0, common_1.assertParamExists)('createTagV1', 'documentCreateTagRequest', documentCreateTagRequest);
            const localVarPath = `/v1/documents/recipients/{recipient_id}/tags`.replace('{recipient_id}', encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (circleAuthorizationToken != null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/documents/recipients/{recipient_id}/tags`,
                sdkMethod: 'createTagV1',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(documentCreateTagRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Delete recipient documents |Feature|Dataclass|Permission| |-------|---------|----------| |documents|document|d|
         * @summary Deletes recipient documents permanently.
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocumentByRecipientV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('deleteDocumentByRecipientV1', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('deleteDocumentByRecipientV1', 'recipientId', recipientId);
            const localVarPath = `/v1/documents/recipients/{recipient_id}/documents`.replace('{recipient_id}', encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            if (circleAuthorizationToken != null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/documents/recipients/{recipient_id}/documents`,
                sdkMethod: 'deleteDocumentByRecipientV1',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Delete a document |Feature|Dataclass|Permission| |-------|---------|----------| |documents|document|d|
         * @summary Deletes a document.
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {number} documentId Document ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocumentV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, documentId, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('deleteDocumentV1', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('deleteDocumentV1', 'recipientId', recipientId);
            // verify required parameter 'documentId' is not null or undefined
            (0, common_1.assertParamExists)('deleteDocumentV1', 'documentId', documentId);
            const localVarPath = `/v1/documents/recipients/{recipient_id}/documents/{document_id}`
                .replace('{recipient_id}', encodeURIComponent(String(recipientId)))
                .replace('{document_id}', encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            if (circleAuthorizationToken != null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/documents/recipients/{recipient_id}/documents/{document_id}`,
                sdkMethod: 'deleteDocumentV1',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Download document |Feature|Dataclass|Permission| |-------|---------|----------| |documents|document|r|
         * @summary Allows clients to download documents by redirecting them to the document signed URL.
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {number} documentId Document ID
         * @param {DownloadDocumentV1TypeEnum} [type] Retrieve other versions of the document, such as the thumbnail.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadDocumentV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, documentId, type, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('downloadDocumentV1', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('downloadDocumentV1', 'recipientId', recipientId);
            // verify required parameter 'documentId' is not null or undefined
            (0, common_1.assertParamExists)('downloadDocumentV1', 'documentId', documentId);
            const localVarPath = `/v1/documents/recipients/{recipient_id}/documents/{document_id}/download`
                .replace('{recipient_id}', encodeURIComponent(String(recipientId)))
                .replace('{document_id}', encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            if (circleAuthorizationToken != null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/documents/recipients/{recipient_id}/documents/{document_id}/download`,
                sdkMethod: 'downloadDocumentV1',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Expunges recipient documents |Feature|Dataclass|Permission| |-------|---------|----------| |documents|document|e|
         * @summary Expunges recipient documents permanently.
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        expungeDocumentByRecipientV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('expungeDocumentByRecipientV1', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('expungeDocumentByRecipientV1', 'recipientId', recipientId);
            const localVarPath = `/v1/documents/recipients/{recipient_id}/documents/expunge`.replace('{recipient_id}', encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            if (circleAuthorizationToken != null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/documents/recipients/{recipient_id}/documents/expunge`,
                sdkMethod: 'expungeDocumentByRecipientV1',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get a download URL for document |Feature|Dataclass|Permission| |-------|---------|----------| |documents|document|r|
         * @summary Allows clients to retrieve signed URL by document ID.
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {number} documentId Document ID
         * @param {GetDocumentSignedUrlV1TypeEnum} [type] Retrieve other versions of the document, such as the thumbnail.
         * @param {GetDocumentSignedUrlV1UrlTypeEnum} [urlType] Allows to request upload or download url. Default is download url.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentSignedUrlV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, documentId, type, urlType, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('getDocumentSignedUrlV1', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('getDocumentSignedUrlV1', 'recipientId', recipientId);
            // verify required parameter 'documentId' is not null or undefined
            (0, common_1.assertParamExists)('getDocumentSignedUrlV1', 'documentId', documentId);
            const localVarPath = `/v1/documents/recipients/{recipient_id}/documents/{document_id}/signedUrl`
                .replace('{recipient_id}', encodeURIComponent(String(recipientId)))
                .replace('{document_id}', encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            if (urlType !== undefined) {
                localVarQueryParameter['url_type'] = urlType;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            if (circleAuthorizationToken != null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/documents/recipients/{recipient_id}/documents/{document_id}/signedUrl`,
                sdkMethod: 'getDocumentSignedUrlV1',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get document |Feature|Dataclass|Permission| |-------|---------|----------| |documents|document|r|
         * @summary Returns a document.
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {number} documentId Document ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, documentId, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('getDocumentV1', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('getDocumentV1', 'recipientId', recipientId);
            // verify required parameter 'documentId' is not null or undefined
            (0, common_1.assertParamExists)('getDocumentV1', 'documentId', documentId);
            const localVarPath = `/v1/documents/recipients/{recipient_id}/documents/{document_id}`
                .replace('{recipient_id}', encodeURIComponent(String(recipientId)))
                .replace('{document_id}', encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            if (circleAuthorizationToken != null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/documents/recipients/{recipient_id}/documents/{document_id}`,
                sdkMethod: 'getDocumentV1',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get documents for recipient |Feature|Dataclass|Permission| |-------|---------|----------| |documents|document|r|
         * @summary Returns documents for the recipient.
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {boolean} [includePending] Include Pending Documents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentsV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, includePending, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('getDocumentsV1', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('getDocumentsV1', 'recipientId', recipientId);
            const localVarPath = `/v1/documents/recipients/{recipient_id}/documents`.replace('{recipient_id}', encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (includePending !== undefined) {
                localVarQueryParameter['includePending'] = includePending;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            if (circleAuthorizationToken != null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/documents/recipients/{recipient_id}/documents`,
                sdkMethod: 'getDocumentsV1',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get health summary document |Feature|Dataclass|Permission| |-------|---------|----------| |documents|document|r|
         * @summary Returns health summary document.
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHealthSummaryDocumentV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('getHealthSummaryDocumentV1', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('getHealthSummaryDocumentV1', 'recipientId', recipientId);
            const localVarPath = `/v1/documents/recipients/{recipient_id}/documents/health-summary`.replace('{recipient_id}', encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            if (circleAuthorizationToken != null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/documents/recipients/{recipient_id}/documents/health-summary`,
                sdkMethod: 'getHealthSummaryDocumentV1',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get medication document |Feature|Dataclass|Permission| |-------|---------|----------| |documents|document|r|
         * @summary Returns medication document.
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMedicationsDocumentV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('getMedicationsDocumentV1', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('getMedicationsDocumentV1', 'recipientId', recipientId);
            const localVarPath = `/v1/documents/recipients/{recipient_id}/documents/medications`.replace('{recipient_id}', encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            if (circleAuthorizationToken != null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/documents/recipients/{recipient_id}/documents/medications`,
                sdkMethod: 'getMedicationsDocumentV1',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Handles the pdf job callback.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handlePDFCallbackV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({}, options = {}) {
            const localVarPath = `/v1/documents/pdfs/callback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/documents/pdfs/callback`,
                sdkMethod: 'handlePDFCallbackV1',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Processes pub sub messages for document service. Requires google service account bearer auth token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handlePubsubMessageV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({}, options = {}) {
            const localVarPath = `/v1/documents/pubsub`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/documents/pubsub`,
                sdkMethod: 'handlePubsubMessageV1',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Mark a document as \"read\" by the current user |Feature|Dataclass|Permission| |-------|---------|----------| |documents|document|r|
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {number} documentId Document ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markDocumentReadV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, documentId, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('markDocumentReadV1', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('markDocumentReadV1', 'recipientId', recipientId);
            // verify required parameter 'documentId' is not null or undefined
            (0, common_1.assertParamExists)('markDocumentReadV1', 'documentId', documentId);
            const localVarPath = `/v1/documents/recipients/{recipient_id}/documents/{document_id}/read`
                .replace('{recipient_id}', encodeURIComponent(String(recipientId)))
                .replace('{document_id}', encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            if (circleAuthorizationToken != null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/documents/recipients/{recipient_id}/documents/{document_id}/read`,
                sdkMethod: 'markDocumentReadV1',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Refresh health summary document pdf |Feature|Dataclass|Permission| |-------|---------|----------| |documents|document|c|
         * @summary Refresh health summary document pdf.
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {DocumentRefreshRequest} [documentRefreshRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshHealthSummaryDocumentV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, documentRefreshRequest, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('refreshHealthSummaryDocumentV1', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('refreshHealthSummaryDocumentV1', 'recipientId', recipientId);
            const localVarPath = `/v1/documents/recipients/{recipient_id}/documents/health-summary/refresh`.replace('{recipient_id}', encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (circleAuthorizationToken != null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/documents/recipients/{recipient_id}/documents/health-summary/refresh`,
                sdkMethod: 'refreshHealthSummaryDocumentV1',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(documentRefreshRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Update a document |Feature|Dataclass|Permission| |-------|---------|----------| |documents|document|u|
         * @summary Updates a document.
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {number} documentId Document ID
         * @param {DocumentUpdateDocumentRequest} documentUpdateDocumentRequest update document request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDocumentV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, documentId, documentUpdateDocumentRequest, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('updateDocumentV1', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('updateDocumentV1', 'recipientId', recipientId);
            // verify required parameter 'documentId' is not null or undefined
            (0, common_1.assertParamExists)('updateDocumentV1', 'documentId', documentId);
            // verify required parameter 'documentUpdateDocumentRequest' is not null or undefined
            (0, common_1.assertParamExists)('updateDocumentV1', 'documentUpdateDocumentRequest', documentUpdateDocumentRequest);
            const localVarPath = `/v1/documents/recipients/{recipient_id}/documents/{document_id}`
                .replace('{recipient_id}', encodeURIComponent(String(recipientId)))
                .replace('{document_id}', encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (circleAuthorizationToken != null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/documents/recipients/{recipient_id}/documents/{document_id}`,
                sdkMethod: 'updateDocumentV1',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(documentUpdateDocumentRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Return document tags |Feature|Dataclass|Permission| |-------|---------|----------| |documents|document|r|
         * @summary Returns document tags for the recipient.
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1GetRecipientDocumentTags: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('v1GetRecipientDocumentTags', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('v1GetRecipientDocumentTags', 'recipientId', recipientId);
            const localVarPath = `/v1/documents/recipients/{recipient_id}/tags`.replace('{recipient_id}', encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            if (circleAuthorizationToken != null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/documents/recipients/{recipient_id}/tags`,
                sdkMethod: 'v1GetRecipientDocumentTags',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.DocumentApiAxiosParamCreator = DocumentApiAxiosParamCreator;
/**
 * DocumentApi - functional programming interface
 */
const DocumentApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.DocumentApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create document for recipient |Feature|Dataclass|Permission| |-------|---------|----------| |documents|document|c|
         * @summary Creates a document for the recipient.
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {DocumentCreateDocumentRequest} documentCreateDocumentRequest Create document request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDocumentV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createDocumentV1(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DocumentApi.createDocumentV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Create a tag |Feature|Dataclass|Permission| |-------|---------|----------| |documents|document|c|
         * @summary Creates a tag.
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {DocumentCreateTagRequest} documentCreateTagRequest Create tag request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTagV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createTagV1(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DocumentApi.createTagV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Delete recipient documents |Feature|Dataclass|Permission| |-------|---------|----------| |documents|document|d|
         * @summary Deletes recipient documents permanently.
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocumentByRecipientV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteDocumentByRecipientV1(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DocumentApi.deleteDocumentByRecipientV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Delete a document |Feature|Dataclass|Permission| |-------|---------|----------| |documents|document|d|
         * @summary Deletes a document.
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {number} documentId Document ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocumentV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteDocumentV1(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DocumentApi.deleteDocumentV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Download document |Feature|Dataclass|Permission| |-------|---------|----------| |documents|document|r|
         * @summary Allows clients to download documents by redirecting them to the document signed URL.
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {number} documentId Document ID
         * @param {DownloadDocumentV1TypeEnum} [type] Retrieve other versions of the document, such as the thumbnail.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadDocumentV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.downloadDocumentV1(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DocumentApi.downloadDocumentV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Expunges recipient documents |Feature|Dataclass|Permission| |-------|---------|----------| |documents|document|e|
         * @summary Expunges recipient documents permanently.
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        expungeDocumentByRecipientV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.expungeDocumentByRecipientV1(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DocumentApi.expungeDocumentByRecipientV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get a download URL for document |Feature|Dataclass|Permission| |-------|---------|----------| |documents|document|r|
         * @summary Allows clients to retrieve signed URL by document ID.
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {number} documentId Document ID
         * @param {GetDocumentSignedUrlV1TypeEnum} [type] Retrieve other versions of the document, such as the thumbnail.
         * @param {GetDocumentSignedUrlV1UrlTypeEnum} [urlType] Allows to request upload or download url. Default is download url.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentSignedUrlV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getDocumentSignedUrlV1(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DocumentApi.getDocumentSignedUrlV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get document |Feature|Dataclass|Permission| |-------|---------|----------| |documents|document|r|
         * @summary Returns a document.
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {number} documentId Document ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getDocumentV1(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DocumentApi.getDocumentV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get documents for recipient |Feature|Dataclass|Permission| |-------|---------|----------| |documents|document|r|
         * @summary Returns documents for the recipient.
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {boolean} [includePending] Include Pending Documents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentsV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getDocumentsV1(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DocumentApi.getDocumentsV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get health summary document |Feature|Dataclass|Permission| |-------|---------|----------| |documents|document|r|
         * @summary Returns health summary document.
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHealthSummaryDocumentV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getHealthSummaryDocumentV1(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DocumentApi.getHealthSummaryDocumentV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get medication document |Feature|Dataclass|Permission| |-------|---------|----------| |documents|document|r|
         * @summary Returns medication document.
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMedicationsDocumentV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMedicationsDocumentV1(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DocumentApi.getMedicationsDocumentV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Handles the pdf job callback.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handlePDFCallbackV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.handlePDFCallbackV1(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DocumentApi.handlePDFCallbackV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Processes pub sub messages for document service. Requires google service account bearer auth token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handlePubsubMessageV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.handlePubsubMessageV1(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DocumentApi.handlePubsubMessageV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Mark a document as \"read\" by the current user |Feature|Dataclass|Permission| |-------|---------|----------| |documents|document|r|
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {number} documentId Document ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markDocumentReadV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.markDocumentReadV1(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DocumentApi.markDocumentReadV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Refresh health summary document pdf |Feature|Dataclass|Permission| |-------|---------|----------| |documents|document|c|
         * @summary Refresh health summary document pdf.
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {DocumentRefreshRequest} [documentRefreshRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshHealthSummaryDocumentV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.refreshHealthSummaryDocumentV1(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DocumentApi.refreshHealthSummaryDocumentV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Update a document |Feature|Dataclass|Permission| |-------|---------|----------| |documents|document|u|
         * @summary Updates a document.
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {number} documentId Document ID
         * @param {DocumentUpdateDocumentRequest} documentUpdateDocumentRequest update document request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDocumentV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateDocumentV1(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DocumentApi.updateDocumentV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Return document tags |Feature|Dataclass|Permission| |-------|---------|----------| |documents|document|r|
         * @summary Returns document tags for the recipient.
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1GetRecipientDocumentTags(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1GetRecipientDocumentTags(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DocumentApi.v1GetRecipientDocumentTags']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.DocumentApiFp = DocumentApiFp;
/**
 * DocumentApi - factory interface
 */
const DocumentApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.DocumentApiFp)(configuration);
    return {
        /**
         * Create document for recipient |Feature|Dataclass|Permission| |-------|---------|----------| |documents|document|c|
         * @summary Creates a document for the recipient.
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {DocumentCreateDocumentRequest} documentCreateDocumentRequest Create document request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDocumentV1(params, options) {
            return localVarFp
                .createDocumentV1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Create a tag |Feature|Dataclass|Permission| |-------|---------|----------| |documents|document|c|
         * @summary Creates a tag.
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {DocumentCreateTagRequest} documentCreateTagRequest Create tag request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTagV1(params, options) {
            return localVarFp
                .createTagV1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Delete recipient documents |Feature|Dataclass|Permission| |-------|---------|----------| |documents|document|d|
         * @summary Deletes recipient documents permanently.
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocumentByRecipientV1(params, options) {
            return localVarFp
                .deleteDocumentByRecipientV1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Delete a document |Feature|Dataclass|Permission| |-------|---------|----------| |documents|document|d|
         * @summary Deletes a document.
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {number} documentId Document ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocumentV1(params, options) {
            return localVarFp
                .deleteDocumentV1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Download document |Feature|Dataclass|Permission| |-------|---------|----------| |documents|document|r|
         * @summary Allows clients to download documents by redirecting them to the document signed URL.
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {number} documentId Document ID
         * @param {DownloadDocumentV1TypeEnum} [type] Retrieve other versions of the document, such as the thumbnail.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadDocumentV1(params, options) {
            return localVarFp
                .downloadDocumentV1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Expunges recipient documents |Feature|Dataclass|Permission| |-------|---------|----------| |documents|document|e|
         * @summary Expunges recipient documents permanently.
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        expungeDocumentByRecipientV1(params, options) {
            return localVarFp
                .expungeDocumentByRecipientV1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Get a download URL for document |Feature|Dataclass|Permission| |-------|---------|----------| |documents|document|r|
         * @summary Allows clients to retrieve signed URL by document ID.
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {number} documentId Document ID
         * @param {GetDocumentSignedUrlV1TypeEnum} [type] Retrieve other versions of the document, such as the thumbnail.
         * @param {GetDocumentSignedUrlV1UrlTypeEnum} [urlType] Allows to request upload or download url. Default is download url.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentSignedUrlV1(params, options) {
            return localVarFp
                .getDocumentSignedUrlV1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Get document |Feature|Dataclass|Permission| |-------|---------|----------| |documents|document|r|
         * @summary Returns a document.
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {number} documentId Document ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentV1(params, options) {
            return localVarFp
                .getDocumentV1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Get documents for recipient |Feature|Dataclass|Permission| |-------|---------|----------| |documents|document|r|
         * @summary Returns documents for the recipient.
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {boolean} [includePending] Include Pending Documents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentsV1(params, options) {
            return localVarFp
                .getDocumentsV1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Get health summary document |Feature|Dataclass|Permission| |-------|---------|----------| |documents|document|r|
         * @summary Returns health summary document.
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHealthSummaryDocumentV1(params, options) {
            return localVarFp
                .getHealthSummaryDocumentV1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Get medication document |Feature|Dataclass|Permission| |-------|---------|----------| |documents|document|r|
         * @summary Returns medication document.
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMedicationsDocumentV1(params, options) {
            return localVarFp
                .getMedicationsDocumentV1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Handles the pdf job callback.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handlePDFCallbackV1(params, options) {
            return localVarFp
                .handlePDFCallbackV1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Processes pub sub messages for document service. Requires google service account bearer auth token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handlePubsubMessageV1(params, options) {
            return localVarFp
                .handlePubsubMessageV1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Mark a document as \"read\" by the current user |Feature|Dataclass|Permission| |-------|---------|----------| |documents|document|r|
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {number} documentId Document ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markDocumentReadV1(params, options) {
            return localVarFp
                .markDocumentReadV1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Refresh health summary document pdf |Feature|Dataclass|Permission| |-------|---------|----------| |documents|document|c|
         * @summary Refresh health summary document pdf.
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {DocumentRefreshRequest} [documentRefreshRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshHealthSummaryDocumentV1(params, options) {
            return localVarFp
                .refreshHealthSummaryDocumentV1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Update a document |Feature|Dataclass|Permission| |-------|---------|----------| |documents|document|u|
         * @summary Updates a document.
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {number} documentId Document ID
         * @param {DocumentUpdateDocumentRequest} documentUpdateDocumentRequest update document request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDocumentV1(params, options) {
            return localVarFp
                .updateDocumentV1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Return document tags |Feature|Dataclass|Permission| |-------|---------|----------| |documents|document|r|
         * @summary Returns document tags for the recipient.
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1GetRecipientDocumentTags(params, options) {
            return localVarFp
                .v1GetRecipientDocumentTags(params, options)
                .then((request) => request(axios, basePath));
        },
    };
};
exports.DocumentApiFactory = DocumentApiFactory;
/**
 * DocumentApi - object-oriented interface
 */
class DocumentApi extends base_1.BaseAPI {
    /**
     * URL `/v1/documents/recipients/{recipient_id}/documents`
     * Create document for recipient |Feature|Dataclass|Permission| |-------|---------|----------| |documents|document|c|
     * @summary Creates a document for the recipient.
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {DocumentCreateDocumentRequest} documentCreateDocumentRequest Create document request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createDocumentV1(params, options) {
        return (0, exports.DocumentApiFp)(this.configuration)
            .createDocumentV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/documents/recipients/{recipient_id}/tags`
     * Create a tag |Feature|Dataclass|Permission| |-------|---------|----------| |documents|document|c|
     * @summary Creates a tag.
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {DocumentCreateTagRequest} documentCreateTagRequest Create tag request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createTagV1(params, options) {
        return (0, exports.DocumentApiFp)(this.configuration)
            .createTagV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/documents/recipients/{recipient_id}/documents`
     * Delete recipient documents |Feature|Dataclass|Permission| |-------|---------|----------| |documents|document|d|
     * @summary Deletes recipient documents permanently.
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteDocumentByRecipientV1(params, options) {
        return (0, exports.DocumentApiFp)(this.configuration)
            .deleteDocumentByRecipientV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/documents/recipients/{recipient_id}/documents/{document_id}`
     * Delete a document |Feature|Dataclass|Permission| |-------|---------|----------| |documents|document|d|
     * @summary Deletes a document.
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {number} documentId Document ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteDocumentV1(params, options) {
        return (0, exports.DocumentApiFp)(this.configuration)
            .deleteDocumentV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/documents/recipients/{recipient_id}/documents/{document_id}/download`
     * Download document |Feature|Dataclass|Permission| |-------|---------|----------| |documents|document|r|
     * @summary Allows clients to download documents by redirecting them to the document signed URL.
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {number} documentId Document ID
     * @param {DownloadDocumentV1TypeEnum} [type] Retrieve other versions of the document, such as the thumbnail.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    downloadDocumentV1(params, options) {
        return (0, exports.DocumentApiFp)(this.configuration)
            .downloadDocumentV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/documents/recipients/{recipient_id}/documents/expunge`
     * Expunges recipient documents |Feature|Dataclass|Permission| |-------|---------|----------| |documents|document|e|
     * @summary Expunges recipient documents permanently.
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    expungeDocumentByRecipientV1(params, options) {
        return (0, exports.DocumentApiFp)(this.configuration)
            .expungeDocumentByRecipientV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/documents/recipients/{recipient_id}/documents/{document_id}/signedUrl`
     * Get a download URL for document |Feature|Dataclass|Permission| |-------|---------|----------| |documents|document|r|
     * @summary Allows clients to retrieve signed URL by document ID.
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {number} documentId Document ID
     * @param {GetDocumentSignedUrlV1TypeEnum} [type] Retrieve other versions of the document, such as the thumbnail.
     * @param {GetDocumentSignedUrlV1UrlTypeEnum} [urlType] Allows to request upload or download url. Default is download url.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDocumentSignedUrlV1(params, options) {
        return (0, exports.DocumentApiFp)(this.configuration)
            .getDocumentSignedUrlV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/documents/recipients/{recipient_id}/documents/{document_id}`
     * Get document |Feature|Dataclass|Permission| |-------|---------|----------| |documents|document|r|
     * @summary Returns a document.
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {number} documentId Document ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDocumentV1(params, options) {
        return (0, exports.DocumentApiFp)(this.configuration)
            .getDocumentV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/documents/recipients/{recipient_id}/documents`
     * Get documents for recipient |Feature|Dataclass|Permission| |-------|---------|----------| |documents|document|r|
     * @summary Returns documents for the recipient.
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {boolean} [includePending] Include Pending Documents
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDocumentsV1(params, options) {
        return (0, exports.DocumentApiFp)(this.configuration)
            .getDocumentsV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/documents/recipients/{recipient_id}/documents/health-summary`
     * Get health summary document |Feature|Dataclass|Permission| |-------|---------|----------| |documents|document|r|
     * @summary Returns health summary document.
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getHealthSummaryDocumentV1(params, options) {
        return (0, exports.DocumentApiFp)(this.configuration)
            .getHealthSummaryDocumentV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/documents/recipients/{recipient_id}/documents/medications`
     * Get medication document |Feature|Dataclass|Permission| |-------|---------|----------| |documents|document|r|
     * @summary Returns medication document.
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMedicationsDocumentV1(params, options) {
        return (0, exports.DocumentApiFp)(this.configuration)
            .getMedicationsDocumentV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/documents/pdfs/callback`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @summary Handles the pdf job callback.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    handlePDFCallbackV1(params, options) {
        return (0, exports.DocumentApiFp)(this.configuration)
            .handlePDFCallbackV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/documents/pubsub`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @summary Processes pub sub messages for document service. Requires google service account bearer auth token.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    handlePubsubMessageV1(params, options) {
        return (0, exports.DocumentApiFp)(this.configuration)
            .handlePubsubMessageV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/documents/recipients/{recipient_id}/documents/{document_id}/read`
     * Mark a document as \"read\" by the current user |Feature|Dataclass|Permission| |-------|---------|----------| |documents|document|r|
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {number} documentId Document ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    markDocumentReadV1(params, options) {
        return (0, exports.DocumentApiFp)(this.configuration)
            .markDocumentReadV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/documents/recipients/{recipient_id}/documents/health-summary/refresh`
     * Refresh health summary document pdf |Feature|Dataclass|Permission| |-------|---------|----------| |documents|document|c|
     * @summary Refresh health summary document pdf.
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {DocumentRefreshRequest} [documentRefreshRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    refreshHealthSummaryDocumentV1(params, options) {
        return (0, exports.DocumentApiFp)(this.configuration)
            .refreshHealthSummaryDocumentV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/documents/recipients/{recipient_id}/documents/{document_id}`
     * Update a document |Feature|Dataclass|Permission| |-------|---------|----------| |documents|document|u|
     * @summary Updates a document.
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {number} documentId Document ID
     * @param {DocumentUpdateDocumentRequest} documentUpdateDocumentRequest update document request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateDocumentV1(params, options) {
        return (0, exports.DocumentApiFp)(this.configuration)
            .updateDocumentV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/documents/recipients/{recipient_id}/tags`
     * Return document tags |Feature|Dataclass|Permission| |-------|---------|----------| |documents|document|r|
     * @summary Returns document tags for the recipient.
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    v1GetRecipientDocumentTags(params, options) {
        return (0, exports.DocumentApiFp)(this.configuration)
            .v1GetRecipientDocumentTags(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
exports.DocumentApi = DocumentApi;
exports.DownloadDocumentV1TypeEnum = {
    Document: 'document',
    Thumbnail: 'thumbnail',
};
exports.GetDocumentSignedUrlV1TypeEnum = {
    Document: 'document',
    Thumbnail: 'thumbnail',
};
exports.GetDocumentSignedUrlV1UrlTypeEnum = {
    Download: 'download',
    Upload: 'upload',
};
//# sourceMappingURL=document-api.js.map